<template>
  <div class="form-add">
    <div class="form-add-body">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="姓名" prop="name">
              <el-input size="small" maxLength="255" v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="手机号码" prop="phone">
              <el-input size="small" maxLength="255" v-model="form.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="身份证号" prop="idcard">
              <el-input size="small" maxLength="255" v-model="form.idcard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer" style="float: right;">
        <el-button size="small" @click="customCallback('back')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryStudentDetail,
  queryAllArea,
  queryEdu
} from '../../../api/student'
import {
  selectAreaTree
} from '../../../api/subjectTree'
import {getMarketingChannelList, getLearnPlatformList} from "../../../api/userMG";
export default {
  name: "addStudent",
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data () {
    // 自定义手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^1[345789]\d{9}$/
      if (regMobile.test(value)) {
        return callback()
      }
      // 返回一个错误提示
      callback(new Error('请输入合法的手机号码'))
    }
    //身份证号格式校验
    var isCardId = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入身份证号)");
      } else {
        const reg =
          /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
        const card = reg.test(value);
        if (!card) {
          callback(new Error("身份证号格式有误！"));
        }

        const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        let sum = 0;
        for (let i = 0; i < 17; i++) {
          sum += parseInt(this.form.idcard.charAt(i)) * weights[i];
        }
        const remainder = sum % 11;
        const checkCodeMap = { 0: 1, 1: 0, 2: "X", 3: 9, 4: 8, 5: 7, 6: 6, 7: 5, 8: 4, 9: 3, 10: 2 };
        const checkCode = checkCodeMap[remainder]; // 检查校验码是否匹配

        if (checkCode.toString().toUpperCase() === this.form.idcard.charAt(17).toUpperCase()) {
          callback();
        } else {
          callback(new Error("身份证号无效！"));
        }
      }
    }
    return {
      loading: false, //是显示加载
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        idcard: [
          { required: true, message: "请输入身证件号码", trigger: "blur" },
          { validator: isCardId, trigger: "blur" }
        ],
      },
    }
  },
  created () {
    this.initDate();
  },
  activated() {
    this.initDate();
  },
  methods: {
    initDate() {
      if (this.item != undefined && JSON.stringify(this.item) != '{}') {
        this.queryStudentDetail()
      }
    },

    // 查询详情数据
    queryStudentDetail() {
      queryStudentDetail(this.item).then(res => {
        if (res.code == 200) {
          this.form = res.data;
        }
      })
    },

    // 保存 数据
    // 编辑、增加页面保存方法
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          var data = {
            type: 'saveForm', // 关闭 'refresh',// 执行父页面刷新
            item: this.form
          }
          this.$emit('sonHandleCallback', data)
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    customCallback(type, item) {
      var data = {
        type: type, // 关闭 'refresh',// 执行父页面刷新
        item: item
      }
      this.$emit('sonHandleCallback', data)
    }

  }
}
</script>

<style scoped>
.form-add {
  padding: 0 20px 20px 20px;
  height: 100%;
  overflow: auto;
}
.form-add .form-add-body {
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

/* 头像上传 */
/deep/ .avatar-uploader .el-upload {
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/student/addStudent.vue